import * as React from 'react';

function SvgTrashOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M5.077 5.077l.962 15.384c.045.89.692 1.539 1.538 1.539h8.846c.85 0 1.484-.65 1.538-1.538l.962-15.385" }),
        React.createElement("path", { fill: "currentColor", d: "M3.538 5.077H20.46 3.538z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M3.538 5.077H20.46" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M15.461 8.154l-.384 10.768M8.923 5.077V3.154A1.15 1.15 0 0110.077 2h3.846a1.15 1.15 0 011.154 1.154v1.923H8.923zM12 8.154v10.768V8.154zm-3.462 0l.385 10.768-.385-10.768z" })));
}

export default SvgTrashOutline;
